import * as React from 'react';

import { TaskCtaIcon } from './TaskCardCtaIcon';
import { VerTaskCta } from './TaskCardCta';

const VerTaskCardCta: React.FC = () => (
  <VerTaskCta>
    <TaskCtaIcon />
  </VerTaskCta>
);

export default VerTaskCardCta;
